import { useContext } from "react";
import { WhatsappToUserContext } from "../contexts/WhatsappToUserContext";

const useWhatsappToUser = () => {
  const context = useContext(WhatsappToUserContext);

  if (!context)
    throw new Error("WhatsappToUserContext must be placed within WhatsappToUserProvider");

  return context;
};

export default useWhatsappToUser;
